import React, { useEffect, useState } from "react";
import ScheduleInfo from "./ScheduleInfo";
import { Control, FieldErrors, useForm } from "react-hook-form";

import AvailableCourtsTable from "./AvailableCourtsTable";
import SuccessModel from "./SuccessModel";
import Button from "../global/Button";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../skeletons/Loader";
import { AppDispatch } from "../../lib/redux/store";
import { addLeagueInfo, reset } from "../../lib/redux/slices/leagueSlice";
import Modal from "../global/Modal";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import { toast } from "react-toastify";
import {
  useCreateLeagueMutation,
  useCreateTournamentMutation,
  useEditLeagueMutation,
  useEditTournamentMutation,
  useGetLeagueByIdQuery,
  useGenerateGroupMatchesForTournamentMutation,
  useGenerateGroupMatchesMutation,
  useScheduleTournamentMutation,
  useScheduleLeagueMutation,
} from "../../lib/redux/services/Api";
import { toastMessage } from "../../utils/utils";
import AvailableCourtsTableNew from "../events/AvailableCourtsTableNew";
import ProgressModal from "../global/ProgressModal";
import ScheduleInfoV2 from "./V2/ScheduleInfoV2";

export type FormType = {
  name: string;
  tournament_type?: "Knockouts" | "Round Robin";
  available_courts: number[];
  state: "Pending" | "Draft" | ""; // should be in the system
  organizer_name: string; // char
  club_id: number; // should be in the system
  resource_calendar_id: 2; // should be in the system
  description: string;
  poster: string;
  sponsor_ids: [
    {
      name: string;
      logo: string;
    },
  ];
  prize_ids: [
    {
      name: string;
      //  "logo": string
    },
  ];
  min_number_of_players: number; // integer
  max_number_of_players: number; // integer
  min_players_level: number; // integer
  max_players_level: number; // integer
  price_per_player: number; // float
  players_gender: "Mixed" | "Male" | "Female"; // should be in the system
  join_type: "Both" | "Single" | "Double"; // should be in the system
  terms_and_conditions: string;
  waiting_list: true; // if Typed True or true or 1 means true anything else means false
  start_date: string;
  end_date: string;
  number_of_serves: number;
  game_type: "competitive" | "friendly";
  event_type: "public" | "private";
  match_per_day: boolean;
  registration_deadline_date: string;
  excluded_days: Date[]; // should be list of dates exactly like this
  set_per_match: "1" | "3";
  court_ids: number[]; // should exists in the system  // should be added if tournament type is not King of courts other wise
  court_type: "indoor" | "outdoor"; // for public events, options: (indoor, outdoor)

  selects_days: string[];
  start_time: string;
  end_time: string;
  available_courts_ids: number[];
  unwanted_courts: number[];
  match_duration: number; // float
  allowed_payment: string;
  organizer_ids: any;
};
type Props = {
  type: "leagues" | "tournaments";
  eventType: "new" | "edit" | "duplicate" | "view";
  stage: "rounds" | "knockouts";
};

function CreateSecondStepFormV2({ eventType, type, stage }: Props) {
  const params = useParams();
  const { data, isLoading, isFetching, isSuccess } = useGetLeagueByIdQuery(
    params.id,
    {
      skip: !params.id,
    },
  );
  const [stageType, setStageType] = useState<"rounds" | "knockouts">(stage);
  const [createLeague] = useCreateLeagueMutation();
  const [editTournament] = useScheduleTournamentMutation();
  const [createTournament] = useCreateTournamentMutation();
  const [editLeague] = useScheduleLeagueMutation();
  const [name, setName] = useState<string>("");
  const [Id, setId] = useState<number>(0);
  const [isLoadingMatches, setIsloadingMatches] = useState(false);
  const [loadingModalTitle, setLoadingModalTitle] = useState("Saving courts");
  const createFunction = type === "leagues" ? createLeague : createTournament;
  const editFunction = type === "leagues" ? editLeague : editTournament;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [generateGroupMatches] = useGenerateGroupMatchesMutation();
  const [generateGroupMatchesForTournament] =
    useGenerateGroupMatchesForTournamentMutation();
  const generateMatchesFn = (type: string, id: number, info: any) => {
    if (type === "leagues") {
      return generateGroupMatches({ event_id: id, ...info });
    } else {
      return generateGroupMatchesForTournament({ event_id: id, ...info });
    }
  };

  const { shared }: DictionaryType = useGetDictionary();
  const { id } = useParams();
  const [selectedCourtsLength, setSelectedCourtsLength] = useState<number>(0);
  const [matchCount, setMatchCount] = useState<number>(0);
  const [availableCourtsParams, setAvailableCourtsParams] = useState<any>({});
  const [availableCourtsLoading, setAvailableCourtsLoading] =
    useState<boolean>(false);
  const [selectedCourts, setSelectedCourts] = useState<{ [key: string]: [] }>(
    {},
  );
  const [courts, setCourts] = useState([]);
  const [isAllow, setIsAllow] = useState(true);
  const selectedClub = useSelector((state: any) => state.user.selectedClub);

  const defaultTournament = {
    name: "", // should be in the system
    organizer_name: "", // char
    club_id: selectedClub, // should be in the system
    resource_calendar_id: 0, // should be in the system
    description: "",
    available_courts: [],
    available_courts_ids: [],
    join_type: "Both",
    poster: "",
    sponsor_ids: [
      {
        name: "",
        logo: "",
      },
    ],
    prize_ids: [
      {
        name: "",
        // logo is commented out as per the example
      },
    ],

    terms_and_conditions: "",
    waiting_list: true, // default true
    start_date: "",
    total_price: 0, // new fields for private events
    payment_method_id: 1, // new fields for private events
    end_date: "",
    registration_deadline_date: "",
    excluded_days: [], // list of dates
    set_per_match: "1",
    court_ids: [], // should exist in the system
    court_type: "indoor", // for public events
    selects_days: [],
    start_time: "",
    match_per_day: false,
    unwanted_courts: [],
    end_time: "",
    allowed_payment: "",
    organizer_ids: [],
  };

  const {
    control,
    handleSubmit,
    register,
    setValue,
    trigger,
    watch,
    getValues,
    reset: resetForm,

    formState: { errors, isDirty },
  } = useForm<FormType>({
    disabled: eventType == "view" ? true : false,
    defaultValues: {
      ...defaultTournament,
      ...data?.data,
    },
  });

  useEffect(() => {
    if (data?.data && isSuccess) {
      resetForm({
        ...data.data,
        available_courts:
          stage === "knockouts" && eventType === "edit"
            ? []
            : data.data.available_courts,
      });
      if (data.data.tournament_type === "Knockouts") {
        setStageType("knockouts");
      }
      if (
        eventType === "edit" &&
        watch("state") &&
        watch("state") !== "" &&
        ![
          "Awaiting Knockouts Setup",
          "confirmed_knockouts_setup",
          "Draft",
          "Pending",
        ].includes(watch("state"))
      ) {
        setIsAllow(false);
      } else if (eventType === "view") {
        setIsAllow(false);
      } else {
        setIsAllow(true);
      }
    }
  }, [eventType, data, isSuccess]);

  // useEffect(() => {
  //   //@ts-ignore
  //   setCourts(getValues("court_ids"));
  // }, []);

  const navigate = useNavigate();
  const courtsIds = watch("court_ids");
  const refactor_available_courts = (
    data: any,
    max_number_of_players: number,
  ) => {
    const available_courts_stack = [];
    const selectedCourts = new Set();
    let isValid = true;
    console.log(data);

    for (let keys of Object.keys(data)) {
      if (data[keys].length < Math.ceil(max_number_of_players / 4)) {
        isValid = false;
      }
      if (getValues("unwanted_courts")?.includes(parseInt(keys))) {
        delete data[keys];
      } else {
        available_courts_stack.push({
          id: parseInt(keys),
          court_ids: data[keys].map((item: any) => {
            selectedCourts.add(item.id);
            return item.id;
          }),
        });
      }
    }
    return {
      available_courts: available_courts_stack,
      selectedCourts: Array.from(selectedCourts),
      isValid,
    };
  };

  const handleGenerateGroupMatches = async () => {
    setLoadingModalTitle("Generating matches");
    try {
      await toast.promise(
        //@ts-ignore
        generateMatchesFn(type, params?.id, {
          booking_type: "private_event",
        }).unwrap(),
        toastMessage(
          "Generating matches… may take up to 2 min. Please stay on this page.",
        ),
      );
      setIsloadingMatches(false);
      setLoadingModalTitle("Saving courts");

      if (stage === "rounds") {
        navigate(
          `/competitive/${type}/generate/${data?.data.tournament_type?.toLowerCase() === "knockouts" ? "knockouts" : "rounds"}/` +
            params?.id,
        );
      } else {
        navigate(`/competitive/${type}/knockouts/` + params?.id);
      }
    } catch (error) {
      setIsloadingMatches(false);
      setLoadingModalTitle("Saving courts");
    }
  };

  const onSubmit = async (data: FormType, state: any) => {
    setIsloadingMatches(true);
    try {
      if (state && data.available_courts.length !== undefined) {
        if (eventType === "edit" && params.id) {
          await toast
            .promise(
              ///@ts-ignore
              editFunction({
                data: {
                  available_courts: data.available_courts,
                  unwanted_courts: data.unwanted_courts,
                  end_date: data.end_date,
                  start_time: data.start_time,
                  end_time: data.end_time,
                  match_duration: data.match_duration,
                  court_ids: data.court_ids.map((court: any) => court.id),
                  phase: stageType === "rounds" ? "groups" : "knockouts",
                },
                id: params.id,
              })
                .unwrap()
                .then((res: any) => {
                  //@ts-ignore
                  setId(params.id);
                  setName(data.name);
                }),
              toastMessage(),
            )
            .then(() => {
              if (state !== "Draft" && data.state === "Draft") {
                //@ts-ignore
                resetForm(defaultTournament);
                setOpenModal(true);
              } else {
                //@ts-ignore
                resetForm(data?.data);
                handleGenerateGroupMatches();
                // navigate(`/competitive/${type}`);
              }
            });

          return;
        }
      } else {
        const refactor_available_courts_data = refactor_available_courts(
          data.available_courts,
          data.max_number_of_players,
        );

        if (eventType === "edit" && params.id) {
          await toast
            .promise(
              editFunction({
                data: {
                  available_courts:
                    state === "Draft"
                      ? []
                      : refactor_available_courts_data.available_courts,
                  court_ids: data.court_ids.map((court: any) => court.id),
                  phase: stageType === "rounds" ? "groups" : "knockouts",
                  unwanted_courts: data.unwanted_courts,
                  end_date: data.end_date,
                  start_time: data.start_time,
                  end_time: data.end_time,
                  match_duration: data.match_duration,
                },
                id: params.id,
              })
                .unwrap()
                .then((res) => {
                  //@ts-ignore
                  setId(params.id);
                  setName(data.name);
                }),
              toastMessage(),
            )
            .then(() => {
              if (
                state !== "Draft" &&
                (data.state === "Draft" || data.state === undefined)
              ) {
                //@ts-ignore
                resetForm(defaultTournament);
                setOpenModal(true);
              } else {
                //@ts-ignore
                resetForm(data?.data);
                handleGenerateGroupMatches();
                // navigate(`/competitive/${type}`);
              }
            });

          return;
        }
      }
    } catch (error) {
      //@ts-ignore
      resetForm(data?.data);
    }
  };

  if (isFetching) return <Loader />;

  return (
    <div className="grid grid-cols-4 gap-[20px]">
      <div className="col-span-4 max-h-[calc(100dvh-220px)] overflow-y-auto hidden-customScroll  pt-3 px-5 flex flex-col gap-5">
        <div className="grid grid-cols-4 gap-[20px] w-full col-span-4">
          <div className="col-span-3">  <ScheduleInfoV2
          type={type}
          control={control}
          errors={errors}
          register={register}
          setValue={setValue}
          trigger={trigger}
          setAvailableCourts={setAvailableCourtsParams}
          isAllow={isAllow}
          setAvailableCourtsLoading={setAvailableCourtsLoading}
          getValue={getValues}
          setCourts={setCourts}
          setSelectedCourts={setSelectedCourts}
          selectedCourts={selectedCourts}
          eventType={eventType}
        /></div>
             <div className="col-span-1 h-[350px] w-full bg-primary rounded-2xl py-[34px] px-[26px] text-white flex flex-col gap-[23px] overflow-y-auto customScroll">
        <div>
          <span className="text-[#CCCCCC]">Summary</span>
          <h3 className="font-bold text-[24px]">{watch("name")}</h3>
          <p className="font-normal text-[#F3F3F3] text-[16px]">
            {watch("tournament_type")} {stage} .{" "}
            {watch("max_number_of_players") / 2} teams
          </p>
        </div>

        <div className="grid gap-[23px]">
          <div className="border-b border-white/50 pb-5 flex justify-between items-center text-[16px] font-bold">
            <p>Allowed courts</p>
            <p>{courtsIds.length || 0}</p>
          </div>
          <div className="border-b border-white/50 pb-5 flex justify-between items-center text-[16px] font-bold">
            <p>Match duration</p>
            <p>{watch("match_duration")} min</p>
          </div>
          <div className="border-b border-white/50 pb-5 flex justify-between items-center text-[16px] font-bold">
            <p>Selected date</p>
            <p>
              {watch("start_date")} to <br /> {watch("end_date")}
            </p>
          </div>
          <div className="border-b border-white/50 pb-5 flex justify-between items-center text-[16px] font-bold">
            <p>Reserved slots</p>
            <p className="text-primaryYellow">{selectedCourtsLength || 0}</p>
          </div>
          <div className="border-b border-white/50 pb-5 flex justify-between items-center text-[16px] font-bold">
            <p>Number of matches</p>
            <p className="text-primaryYellow">
              {/* {new Set(Object.values(selectedCourts).flat()).size} */}
              {matchCount}
            </p>
          </div>
        </div>
      </div>
        </div>
       
        <AvailableCourtsTable
          isAllow={isAllow}
          setMatchCount={setMatchCount}
          availableCourtsParams={availableCourtsParams}
          setAvailableCourtsLoading={setAvailableCourtsLoading}
          availableCourtsLoading={availableCourtsLoading}
          control={control}
          getValue={getValues}
          watch={watch}
          selectedCourtsLength={selectedCourtsLength}
          setSelectedCourtsLength={setSelectedCourtsLength}
          selectedCourts={selectedCourts}
          setSelectedCourts={setSelectedCourts}
          setValue={setValue}
          setAvailableCourtsParams={setAvailableCourtsParams}
          type={type}
          stage={stageType}
        />

        <div className=" flex pt-2 gap-3 justify-end w-full items-center pr-4 pb-4">
          {eventType == "view" ? (
            <Button
              customeStyle=" text-red-500 hover:border hover:border-red-500 p-3 px-2 rounded-full w-[200px]"
              text={shared.back}
              width="150px"
              type="submit"
              onClick={(e) => {
                e.preventDefault();

                navigate(`/competitive/${type}/view/step1/${id}`);
              }}
            />
          ) : (
            <>
              <Button
                customeStyle=" text-red-500 hover:border hover:border-red-500 p-3 px-2 rounded-full w-[200px]"
                text={shared.cancel}
                width="150px"
                type="button"
                onClick={(e) => {
                  e.preventDefault();

                  // dispatch(reset());
                  navigate("/competitive/" + type);
                }}
              />
              {(!getValues("state") || getValues("state") === "Draft") && (
                <Button
                  customeStyle=" text-primary dark:text-white  p-3 px-2 rounded-full w-[200px]"
                  text={shared.save_for_later || "save for later"}
                  width="150px"
                  type="button"
                  onClick={async (e) => {
                    e.preventDefault();

                    await onSubmit(getValues(), "Draft");
                  }}
                />
              )}
              <Button
                customeStyle="bg-primary text-white dark:text-primary dark:bg-primaryYellow p-3 px-2 rounded-full w-[200px]"
                text={shared.save_and_publish}
                width="150px"
                type="submit"
                onClick={handleSubmit((formData: FormType) => {
                  if (matchCount > selectedCourtsLength) {
                    toast.error(
                      `Please select ${
                        matchCount - selectedCourtsLength
                      } courts to complete`,
                    );
                    return;
                  }
                  onSubmit(formData, "Pending");
                })}
              />
            </>
          )}
        </div>
        {isLoadingMatches && (
          <Modal
            isOpen={true}
            onClose={() => {
              // dispatch(reset());
              setOpenModal(isLoadingMatches);
            }}
            modalMaxWidth="max-w-[550px]"
          >
            {/* <SuccessModel
            type={type}
            start_date={getValues("start_date")}
            id={Id}
            name={name}
          /> */}
            <ProgressModal
              loadingModalTitle={loadingModalTitle}
              isLoadingMatches={isLoadingMatches}
            />
          </Modal>
        )}
      </div>
      
    </div>
  );
}

export default CreateSecondStepFormV2;
